import { createContext } from 'react';

import type { ReactElement } from 'react';

import { useProfile } from 'providers/UserProfileProvider';
import { UserStatus } from 'types/__generated__';

interface AuthorisationProviderProps {
  children: ReactElement;
}

const AuthorisationContext = createContext(null);

export function AuthorisationProvider({ children }: AuthorisationProviderProps) {
  return <AuthorisationContext.Provider value={null}>{children}</AuthorisationContext.Provider>;
}

interface RequireAuthorisationProps {
  children: ReactElement;
  suspended?: ReactElement;
  unauthorized?: ReactElement;
}

export function RequireAuthorisation({ children, suspended, unauthorized }: RequireAuthorisationProps) {
  const profile = useProfile();
  if (profile?.enabledModules.length !== 0) return children;
  if (profile?.status === UserStatus.Suspended && suspended) return suspended;
  if (unauthorized) return unauthorized;

  return null;
}
